import React, { useState, useCallback } from 'react'

import { useSettingsUpdate } from 'hooks'

type ContextProps = {
    objectFilter: number | any[] | string | null,
    fromFilter: string | null,

    setObjectFilter: (v: number | any[] | string | null, u?: boolean) => void,
    setFromFilter: (v: string | null, u?: boolean) => void,
}

/* v8 ignore next */
const defaultMethod = (_: number | any[] | string | null, __?: boolean) => {}

/* v8 ignore start */
const IxGlobalFilterContext = React.createContext<ContextProps>({
    objectFilter: null,
    fromFilter: null,

    // empty default methods used in testing without provider
    setObjectFilter: defaultMethod,
    setFromFilter: defaultMethod,
})
/* v8 ignore end */

const IxGlobalFilterProvider = (props: any) => {
    const [objectFilter, setObjectFilter] = useState<number | any[] | string | null>(null)
    const [fromFilter, setFromFilter] = useState<string | null>('')

    const updateSetting = useSettingsUpdate()

    const _setObjectFilter = useCallback((val: number | any[] | string | null, updateSettings=true) => {
        setObjectFilter(val)
        if (updateSettings) { updateSetting('object_filter', val) }
    }, [updateSetting])

    const _setFromFilter = useCallback((val: string | null, updateSettings=true) => {
        setFromFilter(val)
        if (updateSettings) { updateSetting('timerange_filter', val) }
    }, [updateSetting])

    return (
        <IxGlobalFilterContext.Provider value={{objectFilter, setObjectFilter: _setObjectFilter, fromFilter, setFromFilter: _setFromFilter}}>
            {props.children}
        </IxGlobalFilterContext.Provider>
    )
}

const useIxGlobalFilter = () => React.useContext(IxGlobalFilterContext)

export {
    IxGlobalFilterProvider,
    useIxGlobalFilter
}
